export type AppErrorCode =
  | "VALIDATION_ERROR"
  | "INVALID_URL"
  | "UNAUTHORIZED"
  | "FORBIDDEN"
  | "NOT_FOUND"
  | "GONE"
  | "ALIAS_TAKEN"
  | "ALIAS_INVALID"
  | "RATE_LIMITED"
  | "QUOTA_EXCEEDED"
  | "CODE_GENERATION_FAILED"
  | "INTERNAL";

export class ApiError extends Error {
  readonly code: AppErrorCode;
  readonly status: number;

  constructor(args: { code: AppErrorCode; message: string; status: number }) {
    super(args.message);
    this.name = "ApiError";
    this.code = args.code;
    this.status = args.status;
  }
}

export function isApiError(err: unknown): err is ApiError {
  return err instanceof ApiError;
}
